import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import PaymentView from "features/application/payment/view";

class Payment extends Component {
  constructor(props) {
    super(props);

    this.validityReference = React.createRef();

    this.goToNextStep = this.goToNextStep.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { removeValidField, setInvalidField } = this.props;

    if (
      this.validityReference.current &&
      nextProps.validFields &&
      nextProps.validFields.includes("validity")
    ) {
      let validity = new Date(
        parseInt(`20${this.validityReference.current.value.split("/")[1]}`),
        parseInt(this.validityReference.current.value.split("/")[0]) - 1,
        new Date().getUTCDate()
      );

      if (
        validity <
          new Date(
            new Date().getUTCFullYear(),
            new Date().getUTCMonth(),
            new Date().getUTCDate()
          ) ||
        validity >
          new Date(
            new Date().getUTCFullYear() + 50,
            11,
            new Date().getUTCDate()
          )
      ) {
        removeValidField("validity");
        setInvalidField("validity");
      }
    }
  }

  goToNextStep() {
    this.props.history.replace("/application/email-confirmation");
  }

  render() {
    const {
      errorCodes,
      billingAddress,
      deleteCreditCard,
      backToPreviousStep,
      sendApiRequest,
    } = this.props;

    return (
      <PaymentView
        errorCodes={errorCodes}
        billingAddress={billingAddress}
        validityReference={this.validityReference}
        deleteCreditCard={deleteCreditCard}
        backToPreviousStep={backToPreviousStep}
        sendApiRequest={sendApiRequest}
        goToNextStep={this.goToNextStep}
      />
    );
  }
}

Payment.propTypes = {
  errorCodes: PropTypes.object,
  billingAddress: PropTypes.object,
  deleteCreditCard: PropTypes.func,
  validFields: PropTypes.array,
  removeValidField: PropTypes.func,
  setInvalidField: PropTypes.func,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
  history: PropTypes.object,
};

export default withRouter(Payment);
